import React from "react";

import {ButtonWrapper} from "cstar-react-primitives";
import {FormattedMessage} from "react-intl";
import classNames from "classnames/dedupe";
import PropTypes from "prop-types";

import { cashbotName } from './coreUtils';

export const PrintButton = ({printMessage, cssClassNames}) => (
    <div className="print-button-wrap">
        <ButtonWrapper
            type="button"
            onClick={() => window.print()}
            cssClass={classNames("print-button", "no-print", {...cssClassNames})}
            alt={printMessage}
            cashbotName={cashbotName}
        >
            <FormattedMessage {...printMessage} />
            <div className="print-button-icon" />
        </ButtonWrapper>
    </div>
);

PrintButton.propTypes = {
    printMessage: PropTypes.object.isRequired,
    cssClassNames: PropTypes.object,
};

PrintButton.defaultProps = {
    cssClassNames: {}
};
